<template>
	<div
		data-testid="processamento-avancado-component"
		class="container__processamento__avancado"
	>
		<!-- <h1>{{`${$t('processing')} > ${isCubagem ? $t('logging') : $t('inventory')} > ${$t('model')}`}}</h1> -->
		<div class="content__processamento__avancado">
			<Card
				style="background-color: white; height: 100%"
				class="settings__section"
				data-testid="advanced-processing-settings-section"
			>
				<div
					style="
						display: flex;
						justify-content: space-between;
						flex-direction: column;
						height: 100%;
					"
				>
					<slot name="registry-fields" />
					<slot name="action-buttons" />
				</div>
			</Card>
			<Card
				style="background-color: white; height: 100%"
				class="chart__section"
				data-testid="advanced-processing-chart-section"
			>
				<slot name="modeling-preview" />
			</Card>
			<!-- <Card
        style="background-color: white; height: 100%"
        class="statistics__section"
        data-testid="advanced-processing-statistics-section"
      >
        <div style="display: flex; justify-content: space-between; flex-direction: column; height: 100%">
          <slot name="checkout-preview" />
        </div>

      </Card> -->
		</div>
	</div>
</template>

<script>
import Card from '../../components/Card/Card.vue'

export default {
	components: {
		Card,
	},
	props: {
		modelo: {
			type: Object,
			required: false,
		},
	},
	computed: {
		isCubagem() {
			return window.location.pathname === '/cubagem'
		},
	},
}
</script>

<style scoped>
.container__processamento__avancado {
	position: fixed;
	left: 0;
	top: 2.5rem;
	height: 100%;
	width: 100vw;
	z-index: 0;
	font-size: 0.75rem;
	background-color: #f5f5f5;
	overflow: auto;
}

.content__processamento__avancado {
	height: 93vh;
	margin-top: 1rem;
}

.content__processamento__avancado {
	display: grid;
	grid-template-columns: 1fr 3fr;
	gap: 0.5rem;
	padding: 0 1rem 1rem 1rem;
}

h1 {
	margin-top: 1rem;
	margin-left: 1rem;
	font-size: 1.2rem;
	font-weight: 700;
	color: rgb(var(--color-primary));
}
</style>
